import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";
import { typeOptions, statusOptions } from "./labels";

export const filterSchema: Schema = {
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  type: {
    label: "Тип",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [{ label: "Все типы", value: "" }, ...typeOptions],
  },
  status: {
    label: "Статус",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "quick",
    options: [{ label: "Все статусы", value: "" }, ...statusOptions],
  },
};
